import {
    type FC
} from "react";
import {
    View
} from "react-native";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useCodeViewerContext
} from "../../context";
import type {
    ICodeViewerHeaderProps
} from "../../type";
import stylesheet, {
    getCodeHeaderStyle
} from "../../stylesheet";

const CodeViewerHeader: FC<ICodeViewerHeaderProps> = ({
    children,
    style,
    ...props
}) => {
    const context = useCodeViewerContext({
        part: "header"
    });

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(context?.customTheme);

    if(!context) {
        return null;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.header,
            getCodeHeaderStyle({
                borderRadius: context.borderRadius,
                size: context.size,
                type: context.type,
                controlPaddings,
                controlHeights,
                shapeConfigs,
                borders,
                colors,
                spaces
            })
        ]}
    >
        {children}
    </View>;
};
export default Object.assign(CodeViewerHeader, {
    codeViewerPart: "header" as const
});
